/* eslint-disable @typescript-eslint/no-restricted-imports */
import { useEffect } from 'react';
import { useFormContext } from 'react-hook-form';

import { useQuestionLibraryStore } from '~/common/components/QuestionLibrary/store/questionLibraryStore';

import { CALCULATION_METHODS } from '../constants';

export const useTaxRateSideEffect = () => {
  const { watch, setValue } = useFormContext();
  const totalValue = useQuestionLibraryStore((s) => s.screenData?.totalValue);
  const watchTaxRate = watch('taxRate');
  const calculationMethod = watch('calculationMethod');

  useEffect(() => {
    if (calculationMethod !== CALCULATION_METHODS.TAX_RATE) return;
    const computedTaxRate = (watchTaxRate / 100) * (totalValue || 0);
    setValue(
      'annualQualifyingAmount',
      Number.parseFloat(computedTaxRate.toFixed(2)),
    );
  }, [watchTaxRate, totalValue, calculationMethod, setValue]);

  return null;
};

export const useMillageRateSideEffect = () => {
  const { watch, setValue } = useFormContext();
  const totalValue = useQuestionLibraryStore((s) => s.screenData?.totalValue);
  const watchMillageRate = watch('millageRate');
  const calculationMethod = watch('calculationMethod');

  useEffect(() => {
    if (calculationMethod !== CALCULATION_METHODS.MILLAGE_RATE) return;
    const computedMillageRate = (watchMillageRate / 1000) * (totalValue || 0);
    setValue(
      'annualQualifyingAmount',
      Number.parseFloat(computedMillageRate.toFixed(2)),
    );
  }, [watchMillageRate, totalValue, calculationMethod, setValue]);

  return null;
};

export const useShockLetterDisableSideEffect = () => {
  const { watch, setValue } = useFormContext();
  const areTaxesBasedOnLandOnlyValue = watch('areTaxesBasedOnLandOnlyValue');
  const calculationMethod = watch('calculationMethod');

  useEffect(() => {
    const shouldDisable =
      areTaxesBasedOnLandOnlyValue === 'yes' &&
      calculationMethod === CALCULATION_METHODS.NOT_PROVIDED;

    if (shouldDisable) {
      setValue('generateShockLetter', false);
    }
  }, [areTaxesBasedOnLandOnlyValue, calculationMethod, setValue]);

  return null;
};
